import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
/**
 * Used modules if vuex store setup is anything other than basic
 * https://vuex.vuejs.org/guide/modules.html
 */
export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  }
})
